import type { IntegrationManifestService } from '@pigello/pigello-matrix';

type ServiceCapabilities = {
  events: boolean;
  webhooks: boolean;
  crons: boolean;
  activationVariables: boolean;
  trackedEntities: boolean;
};

// What a service *can* have, straight from what its manifest version declares.
export function getServiceCapabilities(
  service: IntegrationManifestService | undefined
): ServiceCapabilities {
  if (!service) {
    return {
      events: true,
      webhooks: true,
      crons: true,
      activationVariables: true,
      trackedEntities: true,
    };
  }

  return {
    events: Object.keys(service.events ?? {}).length > 0,
    webhooks: Object.keys(service.webhooks ?? {}).length > 0,
    crons: Object.keys(service.crons ?? {}).length > 0,
    activationVariables:
      Object.keys(service.activation_variables ?? {}).length > 0 ||
      service.require_personal_information_access,
    trackedEntities: Object.keys(service.entities ?? {}).length > 0,
  };
}
